import { getCurrencySymbol } from ".";

export const ENGLISH_TRANSLATIONS = {
  common: {
    //EO
    cards: "Cards",
    save: "Save",
    enterDept: "Enter department",
    selectDept: "Select department",
    emailConfirmation: "Email confirmation",
    confirmationLoading: "Please wait while we confirm your email",
    checkEmail: "Check your email for a follow-up link",
    resetPasswordEmail:
      "An email to reset your password has been sent to your box",
    resetSuccess: "Reset successful",
    noApprovalPersonel: "No Approval Personnel",
    //
    date: "Date",
    station: "Station",
    status: "Status",
    view: "View",
    details: "Details",
    noRecord: "No record",
    upload: "Upload",
    description: "Description",
    remark: "Remark",
    updated: "Updated",
    copied: "Copied",
    cash: "Cash",
    cheque: "Cheque",
    invalidDept: "Department already exists",

    approved: "Approved",
    rejected: "Rejected",
    pending: "Pending",
    reason: "Reasons",
    department: "Department",
    role: "Role",
    Bonus: "Bonus",
    Deduction: "Deduction",
    deductions: "Deductions",
    Salary: "Salary",
    setup: "Setup",
    Basic: "Basic",
    allowance: "Allowance",
    Tax: "Tax",
    Pension: "Pension",
    From: "From",
    To: "To",
    type: "Type",
    edit: "Edit",
    numStation: "Number of station",
    with: "with",
    numStaff: "Number of staff",
    yes: "Yes",
    no: "No",
    setBy: "Set by",
    noData: "No data available",
    createNew: "Create new",
    delete: "Delete",
    update: "Update",
    total: "Total",
    inputReason: "Enter reason",
    selected: "selected",
    cancel: "cancel",
    loading: "Loading",
    noPageAccess:
      "You don't have the required role(s) to access that page, contact your admin for access",
    totalIncluding: "in total, including a",
    loginSuccess: "Login successful",
    imageSelectError: "Please select a valid image file",
    ip: "IP",
    count: "Count",
    stationCode: "Station code",
    condition: "Condition",
    na: "N/A",
    title: "Title",
    exploreFeature: "Explore feature",
    feature: "Feature",
    release: "Release",
    profile: "Profile",
    uploadedBy: "Uploaded by",
    totalRows: "Total Rows",
    successfulRows: "Successful Rows",
    failedRows: "Failed Rows",
    message: "Message",
    stationCompanion: "Station Companion",
    user: "User",
    fileSize: "File size must be 10MB or less.",
    excelValidation: "Please select a valid Excel file.",
    fileUploadValidation: "Please upload a file",
    downloadTemplate: "Click here to download template",
    fileUploadedSuccessfully: "File uploaded successfully",
    fileDownloaded: "File downloaded",
    whatsappPhoneNumber: "Whatsapp phone number",
    whatsappPhoneNumberExplained:
      "This whatsapp phone number is used to receive reports",
      downloadFile: "Download file"
  },

  //CH
  login: {
    leftHeader: "Scale with epump",
    leftText:
      "Explore ePump Africa's sophisticated web- based station monitoring platform, designed to empower station owners with efficient fuel inventory management, pump monitoring, pricing control.",
    rightHeader: "Login",
    signIn: "Sign in",
    rightSubText: "Sign in to continue your journey",
    contactGrey: "Don't have an account?",
    contactGreen: "Contact sales",
    noAccess: "You do not have any of the required roles to access the portal",
  },
  forgotPassword: {
    rightHeader: "Forgot password?",
    resetPassQ: "Reset password?",
    resetPass: "Reset password",
    rightSubText:
      "Don't worry! it happens. please enter the address associated with your account.",
  },
  resetPassword: {
    rightHeader: "Set a new password",
    rightSubText: "Please enter code sent to your email address",
  },
  contactSales: {
    rightHeader: "Contact sales",
    rightSubText: "Sign in to continue your journey",
  },
  callBack: {
    rightHeader: "Call back request sent",
    rightSubText: {
      1: "We sent a sales brochure document to your email:",
      2: "NNPCretail@gmail.com",
      3: "Check your mail to download the brochure. Or contact sales representatives",
    },
  },
  maintenanceDrawer: {
    requestId: "Request ID",
    subject: "subject",
  },
  //

  // EO
  calendar: {
    selectDate: "Select Date",
  },

  drystockList: {
    products: "Products",
    addProduct: "Add a product",
    newToDrystock: "New to dry stock",
    shortDesc1: "epump is here to help you manage your non fuel products in",
    shortDesc2: "your stations",
    manageProduct: "Manage Products",
    mpExcerpt:
      'Click "Add a product" to input details like name, category, SKU, and unit price, then save to list items in your inventory.',
    manageSupply: "Manage Supply",
    msExcerpt:
      "Record new supplies by entering quantities, supplier details, and date received to keep inventory updated.",
    trackSales: "Track Sales",
    tsExcerpt:
      "Log sales data such as product name, quantity sold, sale date, and price to monitor stock turnover and revenue",
  },

  addProduct: {
    productSize: "Product size",
    productName: "Product name",
    numberPlaceholder: "NGN 0.00",
    productDesc: "Product description",
    productCategory: "Product category",
    enterProductName: "Enter product name",
    qtyUnit: "Quantity per unit",
    productImage: "Product image",
    enterQtyUnit: "Enter quantity per unit",
    enterProductDesc: "Enter product description",
    uploadRule: "Upload at least one image",
  },

  region: {
    dateCreated: "Date created",
    region: "Region",
    create: "Add region",
    delete: "Delete region",
    update: "Update region",
    stations: "Stations",
    successCreate: "Successfully created region",
    successDelete: "Successfully deleted region",
    successUpdate: "Successfully updated region",
    unMappedSuccess: "Successfully unmapped station",
    confirmUnMap: "Are you sure you want to unmap this station?",
  },

  regionStations: {
    dealer: "Dealer",
    name: "Name",
    city: "City",
    state: "State",
  },
  managePumpLock: {
    pumpMgt: "Pump management",
    manageLock: "manage pump lock",
    pumpName: "Pump name",
    pumpTot: "Pump totalizer",
    lastDT: "Last dispense time",
    status: "Status",
    pumpManu: "Pump manufacturer",
    pumpModel: "Pump model",
    selectStation: "Select station",
    allPumps: "All pumps",
    passwordDesc: "Please enter your password to continue",
    password: "Password",
    schedulePumpLock: "Schedule pump-lock",
  },

  pumpMode: {
    pageTitle: "Pump mode",
    pumpModeRequest: "Pump mode request",
    CTAdesc: "Allows users to raise request for pump mode change",
    addRequest: "Add request",
    addMode: "Add pump mode",
    selectMode: "Select pump mode",
    attendantMode: "Attendant mode",
    selfServiceMode: "Self service mode",
    sendRequest: "Send request",
    pumpWarnTitle: "Sorry, we can't update mode for your setup",
    pumpWarnDesc: "Selected entities don't have stations with pumps",
    passwordDescription:
      "Please enter the password to confirm pump mode update.",
    confirmPumpModeUpdate: "Confirm Pump Mode Update",
    reqBy: "Requested by",
    reqMode: "Requested mode",
    successToast: "Successfully approved request",
    deniedToast: "Successfully denied request",
  },

  pumpDetails: {
    sourceTank: "Source Tank",
    pumpTrans: "Pump transactions",
    throughput: "Throughput",
    activityLog: "Activity log",
    calibrationLog: "Calibration log",
    totalVolDispenced: "Total volume dispensed",
    totalTrans: "Total transactions",
    avgLitre: "Avg. litre per transaction",
    amountSold: "Amount sold",
    dateTime: "Date/Time",
    openingTime: "Opening time",
    openingReading: "Opening reading (L)",
    closingTime: "Closing time",
    closingReading: "Closing reading (L)",
    volumeDispensed: "Volume dispensed (L)",
    average: "Average (L)",
    amount: `Amount (NGN)`,
    attendant: "Attendant",
    variance: "Variance",
    logType: "Log type",
    errorCode: "Error code",
    calibrationValue: "Calibration value",
    setTimeBound: "Set time bound",
    timeBound: "Time bound calibration value",
    startingTime: "Starting time",
    closedTime: "Closed time",
    authorizedBy: "Authorized by",
    salesType: "Sale type",
    event: "Event",
    oldValue: "Old value",
    newValue: "New value",
  },

  dashboard: {
    wetRevenue: "WET STOCK REVENUE",
    dryRevenue: "Dry STOCK REVENUE",
    potentialSales: "Potential sales variance",
    productStock: "Product stock",
    volume: "Volume",
    openingStock: "Opening stock",
    productReceived: "Product received",
    pumpSales: "Pump sales",
    tankSales: "Tank sales",
    expectedVariance: "Expected variance",
    totalRevenue: "Total revenue",
    wetStock: "Wet stock",
    dryStock: "Dry stock",
    quickActions: "Quick actions",
    updatePumpPrice: "Update pump price",
  },
  reports: {
    totalStationSales: "Total station sales",
    totalAmountSold: "Total amount sold",
    totalVolSold: "Total volume sold",
    stationDetails: "Station details",
    salesReportBreakdown: "Sales report breakdown",
    epumpVolSold: "Epump volume sold",
    manualVolSold: "Manual volume sold",
    epumpVolSoldS: "Epump vol sold",
    manualVolSoldS: "Manual vol sold",
    total: "Total",
    tankVariance: "Tank variance",
    TVReportBreakdown: "Tank variance report breakdown",
    operatingHrs: "Operating hours",
    salesTransactions: "Sales transactions",
    salesTransactionsDetails: "Sales transactions details",
    viewTran: "View transactions",
    dispensedBy: "Dispensed by",
    pumpVariance: "Pump variance",
    tankName: "Tank name",
    tankVariance: "Tank variance",
    probeTrans: "Probe transactions",
    rejectData: "Reject data",
    confirmReject: "Do you want to reject data?",
    reject: "Reject",
    dataRejected: "Data rejected",
    topSales: "Top sales by station",
    topRegion: "Top sales by region",
    wetStockSales: "Wet stock sales",
    seeDetails: "See details",
    itemSupplied: "items supplied",
    totalProductLeft: "Total product left",
    rentalMgt: "Rental management",
    maintenenceMgt: "Maintenance Management",
    mainReq: "TOTAL MAINTENANCE REQUEST",
    pendingReq: "TOTAL PENDING REQUEST",
    fixedReq: "TOTAL FIXED REQUEST",
    totalTankFill: "Total tank fill",
    efuelTankFill: "Automated tankfill",
    manualTankFill: "Manual tankfill",
    topCashflow: "Top cashflow by station",
    valuation: "Valuation",
    totalValuation: "Total valuation",
    totalVol: "Total volume",
    compStationReports: "Company station report",
    send: "Send",
    forward: "Forward",
    sendBranchReport: "Send branch report",
    reportSent: "Report sent successfully ",
    sent: "Sent",
    salesReport: "Sales report",

    dateGenerated: "Date generated",
    dateConsumed: "Date consumed",
  },
  tableColumns: {
    state: "State",
    station: "Station",
    region: "Region",
    totalAmountSold: () => `Total amount sold (${getCurrencySymbol()})`,
    totalVolumeSold: "Total volume sold (L)",
    volumeSold: "volume sold (L)",
    amountSold: () => `Amount sold (${getCurrencySymbol()})`,
    variance: "Variance (L)",
    ATGreading: "ATG reading (L)",
    manualDipping: "Manual dipping (L)",
    epumpVolumeSold: "Epump volume (L)",
    manualVolumeSold: "Manual volume (L)",
    volume: "volume (L)",
    totalVolume: "Total volume (L)",
    dayTransactions: "Day transactions",
    price: () => `Price (${getCurrencySymbol()})`,
    street: "Street",
    amountPaid: () => `Amount paid (${getCurrencySymbol()})`,
    propertyAmount: () => `Propert amount (${getCurrencySymbol()})`,
    BalancetoPay: () => `Balance to Pay (${getCurrencySymbol()})`,
    totalAmount: () => `Total amount (${getCurrencySymbol()})`,
    totalAmountPaid: () => `Total amount paid (${getCurrencySymbol()})`,
    balance: () => `Balance (${getCurrencySymbol()})`,
    tranCount: () => `Transaction count`,
    tranAmount: () => `Transaction amount (${getCurrencySymbol()})`,
    amount: () => `Amount (${getCurrencySymbol()})`,
    amountDue: () => `Amount due (${getCurrencySymbol()})`,
    volumeReceived: "Volume received (L)",
    volumeSold: "Volume sold (L)",
    totalDispensed: "Total dispensed (L)",
    eOpeningReading: "Epump opening reading (L)",
    eLastReading: "Epump closing reading (L)",
    mOpeningReading: "Manual opening reading (L)",
    mLastReading: "Manual closing reading (L)",
    totalSales: () => `Total sales (${getCurrencySymbol()})`,
    retainerSales: () => `Retainer sales (${getCurrencySymbol()})`,
    totalValuation: () => `Total valuation (${getCurrencySymbol()})`,
    valuation: () => `valuation (${getCurrencySymbol()})`,
    walletBalance: () => `Wallet balance (${getCurrencySymbol()})`,
  },

  pos: {
    posTerminal: "POS Terminals",
    createTerminal: "Create Terminal",
    terminalId: "Terminal ID",
    updateTerminal: "Update Terminal",
    serialNo: "Serial No",
    terminalDetails: "Terminal Details",
    successfulTransactions: "Successful transactions",
    failedTransactions: "Failed transactions",
    vendor: "Vendor",
    stan: "Stan",
    rrn: "RRN",
    maskedPan: "Masked Pan",
    reassignPOS: "Re-assign POS",
    emptyTable: "No POS terminal record found ",
    subEmptyTable: "You currently have no records of POS terminal ",
    selectBank: "Select Bank",
    bank: "Bank",
    createTerminal: "Create Terminal",
    pump: "Pump",
    posTran: "Pos Transactions",
    transactionLimit: "Transaction limit",
    fee: "Fee",
    slipHeader: "Slip header",
    slipFooter: "Slip footer",
    serialNo: "Serial No",
    owner: "Owner",
    settleBranch: "Branch settlement",
    terminalType: "Terminal type",
    chargeType: "Charge type",
    chargeValue: "Charge value",
    minValue: "Minimum value",
    maxValue: "Maximum value",
    reassignPOSSuccess: "POS terminal reassigned successfully",
    receiverEmail: "Receiver email",
    selectVendor: "Select Vendor",
    sendReport: "Send report",
  },

  loyalty: {
    loyalty: "Loyalty",
    programName: "Program name",
    pointVol: "Point volume",
    pointVal: "Point value",
    pointEarned: "Point earned",
    redeemablePoint: "Redeemable point",
    editLoyalty: "Edit loyalty",
    deleteLoyalty: "Delete loyalty",
    createLoyalty: "Create loyalty",
    emptyTable: "No loyalty record found ",
    subEmptyTable: "You currently have no loyalty record ",
    startDate: "Start date",
    endDate: "End date",
    dateRange: "Date range",
    enterProgramName: "Enter program name",
    enterPointVol: "Enter point volume",
    enterPointVal: "Enter point value",
    enterRedeemablePoint: "Enter redeemable point",
    selectStartDate: "Select start date",
    selectEndDate: "Self end date",
    voucher: "Voucher",
    wallet: "Wallet",
    redeemType: "Redeem type",
    selectRedeemType: "Select redeem type",
    loyaltyDetails: "Loyalty details",
    totalEarnedPoints: "Total earned points",
    totalPendingPoints: "Total pending points",
    totalRedeemedPoints: "Total redeemed points",
    username: "Username",
    active: "Active",
    currentPointBal: "Current point balance",
    cusEmptyTable: "Loyalty program has no customers ",
    expired: "Expired",
    inactive: "Inactive",
    editLoyalty: "Edit loyalty",
    customerList: "Customers List",
    loyaltyHistory: "Loyalty History",
    volPurchased: "Volume purchased ",
    customer: "Customer",
    customerNumber: "Customer Number",
    noTran: "No transaction",
    deleteLoyalty: "Delete loyalty",
    loyaltyDeleteConfirm:
      "Are you sure you want to delete this loyalty program?",
  },

  general: {
    logout: "Logout",
    confirmLogout: "Are you sure you want to log out?",
    delete: "Delete",
    unmap: "Unmap",
  },

  leaveMgt: {
    leave: "Leave",
    leaveDetails: "Leave details",
    timeOffSummary: "Time off summary",
    availableDays: "Available days",
    daysOff: "Days off",
    totalDays: "Total days",
    noLeaveHistory: "No leave history",
    leaveType: "Leave type",
    dateFrom: "Date from",
    dateTo: "Date to",
    addedOn: "Requested date",
    shiftRecord: "Shift record",
  },
  performanceEval: {
    title: "Performance evaluation",
    evalTitle: "Evaluation title",
    evalPeriod: "Evaluation period",
    performanceCriteria: "Performance criteria",
    addPerformanceCriteria: "Add performance criteria",
    evalList: "Evaluation list",
    addEval: "Add evaluation",
    noEvalList: "No evaluation record",
    createEval: "Create evaluation",
    startPeriod: "Start period",
    endPeriod: "End period",
    selectAllCriteria: "Select all criteria",
    addMoreCriteria: "Add more criteria",
    add: "Add",
    enterCriteria: "Enter criteria",
    fieldsError: "All form fields must be filled",
    criteriaError: "At least one criteria must be selected",
    evalDeleteConfirm:
      "Are you sure you want to delete this evaluation program?",
    performRating: "Performance rating",
    deptManager: "Department manager",
    lastReview: "Last review period",
    enterComment: "Enter comment",
    selectEval: "Select an evaluation",
    evalSuccess: "Evaluation successful",
    editEvaluation: "Edit evaluation",
    selectCriteria: "Select criteria",
    header: "Staff performance comparison",
    staffPerf: "Staff performance",

    subHeader:
      "This feature helps managers make informed decisions regarding resource allocation, training, promotions, or rewards.",
    emptyComparison: "Select staff to compare their performance",
    reasonRejection: "Reason for rejection",
    rejectedBy: "Rejected by",
  },
  //

  //SO
  branchProductStock: {
    pageTitle: "Branch Product Stock",
    lowStockTitle: "Branches with low stock",
    dateFilter: "Date Filter",
    bestSellerTitle: "Best Seller",
    allBranches: "All Branches",
    productsLeft: "products left",
    productStockByBranch: "Product stock by Station",
    today: "Today",
    highStockTitle: "Branches with high stock",
    new: "New",
  },
  singleProduct: {
    products: "Products",
    pageTitle: "Product Details",
    back: "Back",
    supplySummary: "Supply Summary",
    salesSummary: "Sales Summary",
    totalSupply: "Total Supply",
    totalSales: "Total Sales",
    pricePerUnit: "Price per unit",
    quantityPerUnit: "Quantity per unit",
  },
  priceLog: {
    pageTitle: "Price update",
    priceInfoBannerTitle: "Price board display.",
    priceInfoBannerDescription:
      "Keep your pricing synchronized seamlessly between your pump and display pole. Contact us to automate your price display system",
    priceInfoBannerCTA: "Get Price board automation",
    priceChangeLog: "Price change log",
    priceStatusLog: "Price change status log",
    updatePrice: "Update Price",
    errorFetchingPriceLog: "Failed to fetch price log",
    error: "Error",
    failedToFetchProducts: "Failed to fetch products",
    CTAdesc:
      "Update fuel prices across your stations. Changes will be applied to all selected pumps",
    priceStatusDesc:
      "Track the progress of your price changes as they sync across stations and individual pumps.",
    priceStatusDesc2:
      "View all price update requests and monitor their status across stations and pumps in real-time",
    priceStatus: "Price change status",
    priceBreakdown: "Price change breakdown",
    pumpStatus: "Pump status",
    stationLogs: "Station logs",
    emptyAggregate:
      "No aggregated price update requests to display. Aggregated Price changes submitted will appear here with their current status. Check stations log for price update requests per station",
    emptyPriceLog:
      "No price updates yet. Click 'Update Price' to set new fuel prices for your stations.",
    emptyPriceStatus:
      "No active price changes to track. Submit a price update to monitor its rollout status here.",
  },
  manageApproval: {
    manageApproval: "Manage Approval",
    addApproval: "Add approval",
    editApproval: "Edit approval",
    level: "Level",
    position: "Position",
    selectUser: "Select user",
    selectLevel: "Select level",
    saveApproval: "Save approval",
    enterPosition: "Enter position name",
    selectType: "Select type",
    acctDeleteConfirm: "Are you sure you want to remove this account?",
  },
  updatePrice: {
    selectProduct: "Select product",
    enterNewPrice: "Enter New Price",
    selectZone: "Select Region",
    scheduleUpdate: "Schedule Update",
    updatePrice: "Update Price",
    selectRetailOutlet: "Select retail Outlets",
    confirmPriceUpdate: "Confirm Price Update",
    confirmScheduledUpdate: "Confirm Scheduled Update",
    password: "Password",
    enterPassword: "Enter Password",
    enterOTP: "Enter OTP",
    incompleteOTP: "Incomplete OTP",
    passwordDescription:
      "Please enter the password to confirm the price update.",
    passwordDescriptionSchedule:
      "Please enter the password schedule the price update for",
    updatingPrice: "Updating price...",
    error: "Error",
    failedToFetchZones: "Failed to fetch zones",
    failedToFetchProducts: "Failed to fetch products",
    failedToUpdatePrice: "Failed to update price",
    requestPriceChange: "Request price change",
    proceed: "Proceed",
    retry: "Retry",
    sendingOTPMail: "Sending OTP to your Email",
    otpRetryAction: 'OTP expired, resend by clicking "retry" below',
    inputOTPSent: "Please input the OTP sent to",
    codeExpiresIn: "code expires in",
    successPriceUpdate: "Successfully updated price",
    priceWarnTitle: "Sorry, we can't update price for your setup",
    priceWarnDesc: "Selected entities don't have stations with pumps or tanks",
  },
  transactions: {
    pageTitle: "Transactions",
    dateFilter: "Date Filter",
    noTransactions: "No transactions found",
    noTransactionsDescription:
      "Try another set of filters to see transactions.",
    pumpTransactions: "Pump Transactions",
    pumpTransaction: "Pump transaction",
    transactionDetails: "Transaction details",
    attendantName: "Attendant name",
    transactionDate: "Transaction date",
    price: "Price",
    pumpName: "Pump name",
    status: "Status",
    getPDFReceipt: "Get PDF Receipt",
    error: "Error",
    errorFetchingTransactions: "Failed to fetch transactions",
    attendant: "Attendant",
    date: "Date",
    quantitySold: "Quantity Sold (Ltrs)",
    amount: "Amount (NGN)",
    product: "Product",
    status: "Status",
    pumpName: "Pump Name",
    view: "View",
    literSold: "Liter Sold",
    filter: "Filter",
    pumpTransactions: "Pump Transactions",
    selectBranch: "Select Station",
    allBranches: "All Branches",
    allPumps: "All Pumps",
    errorFetchingBranches: "Failed to fetch branches",
    errorFetchingPumps: "Failed to fetch pumps",
    applyFilters: "Apply Filters",
    failedToFetchProducts: "Failed to fetch products",
    selectFilterToSeeTransactions:
      "Apply at least one filter to see transactions",
    allProducts: "All Products",
    selectFilters: "Select filters",
    transactionTime: "Transaction Time",
    pumpDisplayName: "Pump Name",
    salesType: "Sales Type",
    settingsLog: "Settings Log",
    transactionStatus: "Transaction Status",
    literSold: "Liter sold",
  },
  tableExport: {
    export: "Export",
    exportCSV: "Export as CSV",
    exportExcel: "Export as Excel",
    exportPDF: "Export as PDF",
    error: "Error",
    errorExportingData: "Failed to export data",
  },
  groups: {
    branch: "Station",
    pageTitle: "Groups",
    groups: "Groups",
    addNewGroup: "Add new group",
    totalRegions: "Total Regions",
    noGroups: "No group created yet",
    noGroupsDescription: "Click add new button to add new group",
    groupAddedSuccessfully: "Group added successfully",
    groupAddedSuccessfullySubtitle: "Group added successfully",
    error: "Error",
    failedToFetchCategories: "Failed to fetch categories",
    name: "Name",
    enterName: "Enter name",
    email: "Email",
    enterEmail: "Enter email",
    description: "Description",
    enterDescription: "Enter description",
    selectCategory: "Select Category",
    addGroup: "Add Group",
    users: "Users",
    back: "Back",
    createUser: "Create User",
    addExistingUser: "Add Existing User",
    totalUsers: "Total Users",
    userAddedSuccessfully: "User added successfully",
    salesRepresentative: "Sales Representative",
    selectMembers: "Select Members",
    addUser: "Add User",

    accessLevel: "Access level",
    unmapStationfromGroup: "Unmap from group",
    addSubGroup: "Add sub group",
    subGroupName: "Sub group name",
    enterSubgroupName: "Enter sub-group name",
    subGroup: "Sub group",
    totalgroups: "Total groups",
    viewDashboard: "View dashboard",
    mapStation: "Map station",
    addStations: "Add station",
    selectAllStations: "Select all stations",
    mapStationsSuccess: "Successfully mapped stations",
    selectStation: "Please select a station",
    category: "Category",
    addGroupSuccess: "Group added sucessfully",
    unMappedSuccess: "Successfully unmapped user",
    subCategory: "Sub category",
    selectSubCategory: "Select sub category",
    addExistingUserSucess: "Successfully added existing user",
    unMapConfirmation: "Unmap confirmation",
    cancel: "Cancel",
    unmap: "Unmap user",
    enterFirstName: "Enter first name",
    enterLastName: "Enter last name",
    selectAccess: "Select access level",
    usersEmpty: "No Users under this branch",
    confirmUnMap: "Are you sure you want to unmap this user?",
    delete: "Delete",

    // BE
    addSubGroup: "Add sub group",
    updateSubGroup: "Update group",
    updatedSubGroup: "Sub group updated",
    createdSubGroup: "Sub group created",
    subGroup: "Sub group",
    noSubGroups: "No subgroup created yet",
    noSubGroupsDescription: "Click add new button to add new sub group",
    subgroupName: "Subgroup name",
    enterSubgrouopName: "Enter subgroup name",
    selectMember: "Select Member",
    selectGroupHead: "Select group head",
    makeGroupHead: "Make group head",
    groupHeadSelected: "Group head selected",
    deleteGroup: "Delete Group",
    successDelete: "Deleted successfully",
    successfullyUnmapped: "successfully unmapped",
    smallGroup: "group",
    group: "Group",
    unmapGroup: "Unmap",
    confirmDelete: "Are you sure you want to delete?",
    confirmUnmap: "Are you sure you want to unmap?",
  },
  staffManagement: {
    pageTitle: "Staff Management",
    staff: "Staff",
    addNewStaff: "Add New Staff",
    listOfStaff: "List of Staff",
    fullName: "Full name",
    firstName: "First name",
    lastName: "Last name",
    staffId: "Staff ID",
    phoneNumber: "Phone number",
    emailAddress: "Email address",
    status: "Status",
    gender: "Gender",
    city: "City",
    dateOfBirth: "Date of Birth",
    streetAddress: "Street Address",
    state: "State",
    nationality: "Nationality",
    cardAssigned: "Card Assigned",
    emptyStaffList: "No staff found",
    view: "View",
    enterFullName: "Enter full name",
    enterEmail: "Enter email",
    enterPhoneNumber: "Enter phone number",
    enterStaffId: "Enter staff ID",
    enterDateOfBirth: "Enter date of birth",
    enterStreetAddress: "Enter street address",
    selectCategory: "Select Category",
    selectStatus: "Select Status",
    addStaff: "Add Staff",
    selectGender: "Select Gender",
    enterStreetAddress: "Enter street address",
    selectCity: "Select City",
    selectState: "Select State",
    selectNationality: "Select Nationality",
    error: "Error",
    errorFetchingStaff: "Failed to fetch staff",
    success: "Success",
    staffAddedSuccessfully: "Staff added successfully",
    staffEditedSuccessfully: "Staff edited successfully",
    failedToEditStaff: "Failed to edit staff",
    contactInformation: "Contact Information",
    failedToAddStaff: "Failed to add staff",
    staffAddedSuccessfully: "Staff added successfully",
    details: "Details",
    attendanceHistory: "Attendance History",
    rating: "Rating",
    suspendStaff: "Suspend Staff",
    deleteStaff: "Delete Staff",
    editStaff: "Edit Staff",
    staffDetails: "Staff Details",
    attendantCard: "Attendant Card",
    noStaffCardAssigned: "No staff card assigned yet",
    assignCard: "Assign Card",
    assignStaffCard: "Assign Staff Card",
    freezeCard: "Freeze card",
    resetPin: "Reset pin",
    unfreezeCard: "Unfreeze Card",
    blockCard: "Block card",
    personalInfo: "Personal Information",
    contactInfo: "Contact Information",
    cardSerialNumber: "Card Serial Number",
    enterCardSerialNumber: "Enter card serial number",
    cardPin: "Card Pin",
    enterCardPin: "Enter card pin",
    assignCardToStaff: "Assign Card to Staff",
    failedToAssignCard: "Failed to assign card",
    staffCardAssignedSuccessfully: "Staff card assigned successfully",
    deleteStaffFailed: "Failed to delete staff",
    staffDeletedSuccessfully: "Staff deleted successfully",
    deleteStaffConfirmation: "Are you sure you want to delete staff:",
    activateStaff: "Activate Staff",
    suspendStaffConfirmation: "Are you sure you want to suspend staff:",
    activateStaffConfirmation: "Are you sure you want to activate staff:",
    staffStatusToggledSuccessfully: "Staff status toggled successfully",
    staffStatusToggleFailed: "Failed to toggle staff status",
    failedToGetAttendance: "Failed to get attendance",
    attendanceHistory: "Attendance History",
    currentPin: "Current Pin",
    enterCurrentPin: "Enter current pin",
    newPin: "New Pin",
    enterNewPin: "Enter new pin",
    cardPinResetSuccessfully: "Card pin reset successfully",
    failedToResetCardPin: "Failed to reset card pin",
    freezeCardConfirmation: "Are you sure you want to freeze this card?",
    cardFrozenSuccessfully: "Card frozen successfully",
    cardFreezeFailed: "Failed to freeze card",
    blockCardConfirmation: "Are you sure you want to block this card?",
    cardBlockedSuccessfully: "Card blocked successfully",
    cardBlockedFailed: "Failed to block card",
    staffName: "Staff Name",
    averageRateValue: "Average Rate Value",
    date: "Date",
    totalSale: "Total Sale",
    totalPriceSold: "Total Price Sold",
    //EO
    transactionChannel: "Transaction Channel",
    staffRole: "Staff role",
    selectRole: "Select role",
    stationList: "List of stations",

    leaveManagement: "Leave Management",
    leaveSummary: "Leave summary",
    leaveRequest: "Leave Request",
    salaryManagement: "Salary Management",
    deductionTotal: "TOTAL DEDUCTION PAYMENT",
    pendingTotal: "TOTAL PENDING PAYMENT",
    salarySummary: "Salary summary",
    paymentDate: "Payment date",
    grossSalary: "Gross salary",
    netSalary: "Net salary",
    salaryDetails: "Salary details",
    currentSalary: "Current Salary",
    SalarySetup: "Setup salary",
    bonusTitle: "Bonus title",
    bonusAmt: "Bonus amount",
    dedictionDate: "Deduction date",
    deductionTitle: "Deduction title",
    deductionAmt: "Deduction amount",
    salarySetupDate: "Salary setup date",
    reoccurEveryMonth: "Reoccur every month",
    bonusReason: "Reason for bonus",
    enterTitle: "Enter title",
    reasonBonus: "Enter reason for bonus",
    setupBonus: "Setup Bonus",
    addToNextSalary: "Add to next salary",
    deductionReason: "Reason for deduction",
    ReasonForDeduction: "Enter reason for deduction",
    deductNextSalary: "Deduct from next salary",
    setupDeduction: "Setup Deduction",
    dateOfJoining: "Date of joining",
    payPeriod: "Pay period",
    salaryPayout: "SALARY PAYOUT FOR",
    earnings: "Earnings",
    statuaryDeduction: "Statutory Deductions",
    declineRequest: "Decline request",
    approveRequest: "Approve request",
    NoDoc: " No Document uploaded",
    NoRequests: "No leave requests to review yet!",
    enterbasic: "Please enter Basic salary",
    enterAllowance: "Please enter allowance",
    enterTax: "Please enter Tax",
    enterPension: "Please enter pension",
    salarySetupSuccess: "Salary set up successfully",
    editSalary: "Edit Salary",
    salaryEditSucess: "Salary Edited Successfully",
    salaryPaymentEmpty: "No payment history",
    bonusSetUp: "Bonus set up successfully",
    emptyBonus: "No Bonus Payment history",
    emptyDeduction: "No Deduction Payment",
    emptySalary: "No Current Salaries",
    payroll: "Payroll",
    setupPayroll: "Setup payroll",
    payrollList: "Payroll list",
    payrollTitle: "Payroll title",
    payrollEmpty: "No payrolls setup",
    computePayroll: "Compute payroll",
    previewPayroll: "Preview payroll",
    totalpayment: "TOTAL PAYMENT",
    totalStaffPayment: "total staff payment",
    paymentPreviewEmpty: "No payment preview yet",
    paymentPreviewEmptySub: "Kindly setup payroll to preview staff details",
    payrollDetails: "Payroll details",
    // new
    addToPayrollSucess: "Successfully added to preview",
    isActiveLabel: "Make salary active",
    computeSalarySuccess: "Successfully computed salaries",
    enterPayrollTitle: "Kindly enter a payroll title",
    selectPaymentDate: "Kindly select payment date",
    updateToPaid: "Update staff to paid",
    updateSuccess: "Successfully updated status to paid",
    noDeduction: "No deduction this month",
  },
  userManagement: {
    pageTitle: "Manage Users",
    userManagement: "User Management",
    createUser: "Create User",
    listOfUsers: "List of users",
    dateAdded: "Date Added",
    firstName: "First Name",
    lastName: "Last Name",
    fullName: "Full Name",
    email: "Email",
    accessLevel: "Access Level",
    status: "Status",
    details: "Details",
    phoneNumber: "Phone Number",
    userRoles: "User Roles",
    editUserDetails: "Edit user details",
    editUser: "Edit User",
    changeStatus: "Change status",
    deleteUser: "Delete User",
    enterFirstName: "Enter First Name",
    enterLastName: "Enter Last Name",
    enterEmail: "Enter Email",
    enterPhoneNumber: "Enter Phone Number",
    selectAccessLevel: "Select Access Level",
    selectAllRoles: "Select all roles",
    addUser: "Add User",
    error: "Error",
    errorFetchingUsers: "Failed to fetch users",
    success: "Success",
    userAddedSuccessfully: "User added successfully",
    changeUserStatus: "Change user status",
    userStatus: "User Status",
    selectUserStatus: "Select User Status",
    password: "Password",
    enterPassword: "Enter Password",
    update: "Update",
    deleteConfirmation: "Delete Confirmation",
    deleteUserConfirmation: "You are about to delete a user",
    cancel: "Cancel",
    deleteUser: "Delete User",
    delete: "Delete",
    updateUser: "Update User",
    updateRoles: "Update Roles",
    rolesUpdatedSuccessfully: "Roles updated successfully",
    errorUpdatingRoles: "Failed to update roles",
    userDetails: "User Details",
    lastSeen: "Last seen",
    active: "Active User",
    deactivated: "User Deactivated",
    suspended: "User Suspended",
    listOfActivityLog: "Activity Log",
    date: "Date",
    userInformation: "User Information",
    action: "Action",
    emptyActivityLog: "No activity log found",
    userEditedSuccessfully: "User edited successfully",
    failedToEditUser: "Failed to edit user",
    selectAccessLevelPrompt: "Select access level",
    selectAccessLevelDescription: "Select the access level for the user",

    emptyUserList: "No user found",
    userStatusChangedSuccessfully: "User status changed successfully",
    createNewUser: "Create new user",
  },
  //

  // TL
  supply: {
    supply: "Supply",
    supplyProd: "Supply products",
    supplyProdBtn: "Supply a Product",
    recordSupply: "Record supply",
    supplyNow: "Supply now",
    recordNow: "Record now",
    selectProd: "Select Product",
    selectSize: "Select Size",
    supplyQuantity: "How many do you want to supply?",
    addSupply: "Add supply",
    supplySummary: "Supply summary",
    totalSupply: "TOTAL SUPPLY",
    preview: "PREVIEW",
    selectStation: "Select station(s)",
    overallPrice: "OVERALL PRICE",
    totalQuantity: "total quantity",
    pricePerUnit: "Price per unit",
    costPrice: "Cost price",
    cost: "Cost",
    branchSupply: "Branch supply summary",
    topProducts: "Top products",
    supplyDetails: "Supply details",
    supplyHistory: "Supply history",
    salesHistory: "Sales history",
    View: "View",
    Date: "Date",
    retailOutlet: "Retail outlet",
    prodSupplied: "Product supplied",
    QtySupplied: "Quantity supplied",
    totalAmt: "Total amount",
    status: "Status",
    prodName: "Product name",
    prodSize: "Product size",
    product: "Product",
    price: "Price",
    quantity: "Quantity",
    amount: "Amount",
    comment: "Comment",
  },

  productCategory: {
    pageDescription:
      "Discover our expertly curated product categories, designed to help you find exactly what you need.",
    categoryNameLabel: "Category name",
    catNamePlaceholder: "Enter category name",
    prodDescLabel: "Product description",
    prodDescPlaceholder: "Enter description",
    createCategory: "Create category",
    categoryList: "Category list",
    categoryName: "Category name",
    Description: "Description",
  },

  Support: {
    companyName: "Company Name",
    country: "Country",
    manageCompanies: "Manage Companies",
    openTicket: "Open ticket",
    ticketDetails: "Ticket details",
    tickets: "Tickets",
    supportSummary: "Support summary",
    opened: "Opened",
    open: "Open",
    closed: "Closed",
    support: "Support",
    supportAdmin: "Support Admin",
    companyMgt: "Company management",
    companies: "Companies",
    ticketAddSuccess: "Ticket added successfully",
    recordAddSuccess: "Record added successfully",
    ticketSuccess: "Ticket updated successfully",
    recordUpdateSuccess: "Record updated successfully",
    changeTicketStatus: "Change ticket status",
    attendedBy: "Attended by",
    description1:
      "With just a few clicks, you can access individual company accounts, view key details, and perform necessary actions effortlessly, ensuring smooth and efficient management.",
  },

  priceApproval: {
    priceApprovalTitle: "Price approval",
    updatePrice: "Update price",
    newPrice: () => `New price   (${getCurrencySymbol()})`,
    prevPrice: () => `Previous price   (${getCurrencySymbol()})`,
    branch: "Station",
    reqBy: "Request by",
    approvedBy: "Approved by",
    status: "Status",
    awaitApproval: "Awaiting approval",
    approvalHistory: "Approval history",
    requestDetails: "Request details",
    changeReq: " price change request",
    Approve: "Approve",
    Decline: "Decline",
    enterPassword: "Please enter your password to ",
    requests: " the request(s)",
    priceUpdate: " Price update",
    password: "Password",
    declineAll: "Decline all",
    approveAll: "Approve all",
    branchName: "Station name",
    statesError: "Failed to fetch states",
    emptyPriceLog: "No price change log",
    changedBy: "Changed by",
  },
  changePrice: {
    selectState: "Select state",
    selectStates: "Select states",
    outletError: "Failed to fetch outlets",
  },
  Stations: {
    stations: "Stations",
    dealer: "Dealer",
    name: "Name",
    state: "State",
    city: "City",
    mailRecepient: "Mail recipient",
    email: "Email",
    fullName: "Full name",
    phone: "Phone number",
    enterPhone: "Enter phone number",
    enterName: "Enter full name",
    enterMail: "Enter email address",
    addRecipient: "Add mail recipient",
    emptyMailRecepient: "No mail receipients",
    emptyExpenseBudget: "No expense budget",
    manageTarget: "Manage target",
    saleProduct: "Sale product",
    target: "Target",
    enterTarget: "Enter target",
    setTarget: "Set target",
    targetEmpty: "There's no target to manage",
    outstandingCash: "Outstanding cash amount",
    enterAmt: "Enter amount",
    setAmt: "Set amount",
    expenseBudget: "Expense budget for the month",
    enterBudget: "Enter budget",
    setBudget: "Set budget",
    budget: "Budget",
    editTarget: "Edit target",
    successfulTargetUpdate: "Target updated sucessfully",
    setBudget: "Set budget",
    monthlyExpense: "Monthly expense budget",
    amountSet: "Amount set successfully",
    emptyAmountError: "Please enter amount",
    budgetUpdateSucess: "Expense Budget updated sucessfully",
    search: "Search",
    retailOutletEmpty: "No retail outlets",
    recent: "Recent",
    alphabetical: "Alphabetical",
    maxCashAmt: "Maximum cash amount",
    contactSalesForEnquiry: "Contact sales for more enquires",
    confirmRecepientDelete: "Delete mail recepient",
    recepientDeleteConfirmQuestion:
      "Are you sure you want to delete this recepient?",
    deleteRecepientSuccess: "Successfully deleted recepient",
    confirmTargetDelete: "Delete target",
    recepientTargetConfirmQuestion: "Are you sure you want to delete this?",
    createTargetSuccess: "Target added sucessfully",
    deleteTargetSuccess: "Target deleted sucessfully",
    createdBy: "Created by",
  },
  stationRent: {
    uploadContract: "Upload contract",
    uploadImg: "Upload image",
    stationRent: "Station rent",
    addRecord: "Add record",
    rentRecords: "Rent records",
    rentDate: "Rent date",
    enterRentDate: "enter rent date",
    totalAmountPaid: "Total amount paid",
    amountPaid: "Amount paid",
    durationLength: "Duration length",
    enterDL: "enter duration length",
    enterAP: "enter paid amount",
    estimatedRevenue: "Estimated revenue",
    outstandingPayments: "Outstanding payment",
    property: "Property",
    selectProperty: "Select property",
    rentedBy: "Rented by",
    duration: "Duration",
    selectDuration: "Select duration",
    totalRentComplete: "completely paid",
    notCompletelyPaid: "yet to be paid",
    occupantName: "Occupant name",
    paymentStatus: "Payment status",
    rentInformation: "Rent information",
    rentDuration: "Rent duration",
    totalRentAmt: "Total rent amount",
    enterTRA: "enter total amount for rent ",
    createExistingRecord: "Create existing record",
    existingOccupant: "Existing occupant",
    createRecord: "Create record",
    occupantPhone: "Occupant phone number",
    occupantEmail: "Occupant email",
    rentDetails: "Rent details",
    partially: "Partially",
    completed: "Completed",
    download: "Download",
    occupationDetails: "Occupant details",
    newOccupant: "New occupant",
    existingOccupant: "Existing occupant",
    selectOccupant: "Select occupant",
    address: "Address",
    enterAddress: "Enter address",
    enterDurationLength: "enter duration length",
    paymentLog: "Payment log",
    updatePayment: "Update payment",
    sendReminder: "Send reminder",
    occupantDue: "Occupant rent is due",
    paymentReminder: "Payment reminder",
    dueDate: "Due date",
    rentStatus: "Rent status",
    length: "Length",
    activeOccupants: "Active occupants",
    inactiveOccupants: "Inctive occupants",
    totalOccupants: "Total occupants",
    dueProperties: "Due properties",
  },

  property: {
    property: "Property",
    rentalProperty: "Rental Property",
    addProperty: "Add property",
    occupiedProperty: "Occupied Property",
    availableProperty: "Available Property",
    propertyName: "Property name",
    availableDurationType: "Available duration type",
    roomNumer: "Number of room",
    restRoomNumber: "Number of rest room",
    propertyName: "Property name",
    enterPropertyName: "Enter property name",
    propertyDescription: "Property description",
    enterPropertyDescription: "Enter property description",
    additionalDetails: "Additional details",
    enterAdditionalDetails: "Enter additional details",
    propertyImage: "Property image",
    uploadImage: "Upload at least one image",
    addOccupant: "Add Occupant",
    newOccupant: "New occupant",
    enterOccupantName: "Enter occupant name",
    enterOccupantEmail: "Enter occupant email ",
    serviceDescription: "Service description",
    enterServiceDescription: "Enter service description",
    occupantImage: "Upload occupant image",
    availableOccupant: "Available Occupants",
    selectOccupant: "Select occupants",
    occupantDeatils: "OCCUPANT DETAILS",
    TransactionHistory: "Transaction history",
    occupantHistory: "Occupant history",
    paymentDate: "Payment date",
    BalancetoPay: "Balance to pay",
    continue: "Continue",
    yearlyFee: "Yearly fee",
    enterYearlyFee: "Enter Yearly fee",
    monthlyFee: "Monthly fee",
    enterMonthlyFee: "Enter monthly fee",
    weeklyFee: "Weekly fee",
    enterWeeklyFee: "Enter weekly fee",
    enterNoOfRestroom: "Enter number of rest room",
    enterRoomNo: "Enter number of room",
    createProperty: "Create property",
    updatePayment: "Update payment",
    renewContract: "Renew contract",
    terminateContract: "Terminate contract",
    propertyRevenue: "PROPERTY REVENUE",
    balance: "Balance",
    occupantDetails: "Occupant Details",
    contractStart: "Contract start",
    contractEnd: "Contract end",
    renewContract: "Renew contract",
    updatePayment: "Update Payment",
    occupiedEmpty: "No Occupied Property",
    availableEmpty: "No Available Property",
    spaceAvailability:
      "This space is available for any one that what to operate any kind of services in the station",
    editProperty: "Edit property",
    editRentInfo: "Edit rent information",
    deleteProperty: "Delete Property",
    confirmPropertyDelete: "Are you sure you want to delete this property?",
    occupantList: "Occupant list",
    deletePropertySuccess: "Property deleted successfully",
    propertyAmount: "Property Amount(NGN)",
    editOccupant: "Edit occupant",
    update: "Update",
    occupantName: "Occupant name",
    nextPayDue: "Next payment due date",
    noOccupantAdded: "No occupant added",
    clickCC: "Click 'create record' to add new or existing occupant",
    total: "Total property",
    occupied: "Occupied",
    available: "Available",
    dueForPayment: "Due for payment",
    occupants: "Occupants",
    reminderSent: "Reminder sent",
  },
  expenses: {
    manageExpense: "Manage Expense",
    overallExpense: "OVER ALL EXPENSE",
    addCategory: "Add category",
    addNewExpense: "Add new expense",
    expenseSummary: "Expense summary",
    totalExpense: "Total expense",
    categories: "Categories",
    listOfExpense: "List of expense",
    expenseEmpty: "No expenses available",
    enterAmtSpent: "Enter amount spent",
    expenseDescription: "Expense description",
    enterExpenseDescription: "Enter expense description",
    paymentMode: "Mode of payment",
    selectPaymentMode: "Select mode of payment",
    uploadReceipt: "Upload receipt",
    createExpense: "Create expense",
    createExpenseSuccess: "Successfully recorded expense",
    enterCategory: "Enter category",
    categorySuccess: "Successfully created category",
    username: "Username",
    expenseDetails: "Expense details",
    userDetail: "user details",
    contactNumber: "Contact number",
    expenseDesc: "Expense description",
    editExpense: "Edit expense",
    deleteExpense: "Delete Expense",
    updateExpense: "Update expense",
    expenseCategory: "Expense category",
    categoryDescription: "Category description",
    editcategory: "Edit Category",
    editSuccess: "Successfully edited category",
    deleteCategory: "Delete Category",
    deleteCategorySuccess: "Successfully deleted category",
    reimbursed: "Reimbursible",
    reimbursibleExpense: "Reimbursible Expense",
    isReimbursible: "Is Reimbursible",
    status: "Status",
    reason: "Reason",
  },
  report: {
    endofDayReport: "End of day report",
    operationHours: "Operating Hours",
    totalVolumeSold: "Total Volume Sold",
    totalRTT: "Total RTT",
    totalCashSale: "Total Cash Sale",
    eSale: "E-Sale",
    tankName: "Tank Name",
    epumpVolDischarged: "Epump Volume Discharged (L)",
    manualVolDischarged: "Manual Volume Discharged (L)",
    epumpStartVol: "Epump Start Volume(L)",
    epumpEndVol: "Epump End Volume (L)",
    manualStartVolume: "Manual Start Volume (L)",
    manualEndVolume: "Manual End Volume (L)",
    plateNumberWaybill: "Plate number/Waybill",
    startTime: "Start Time",
    endTime: "End Time",
    tankCapacity: "Tank Capacity",
    currentVol: "Current Volume",
    lastFilledDate: "Last Filled Date",
    lastFilledVol: "Last Filled Volume",
    AvgDispensePerDay: "Average Dispense Per Day",
    inventoryEmpty: "No inventory report",
    prodDischargedEmpty: "No products discharged",
    saleVolume: "Sale Volume (L)",
    volRefilled: "Volume Refilled (L)",
    openingVolume: "Opening Volume (L)",
    closingVolume: "Closing Volume (L)",
    tankSalesEmpty: "No tank sales volume ",
    supplus: "Supplus",
    accountSummary: "Account summary",
    viewDetails: "View details",
    expenseMgt: "Expense management",
    quantityReceived: "Quantity received",
    soldQuantity: "Sold quantity",
    esalesSummary: "Esales summary",
    posSales: "POS sales",
    cardSales: "Card sales",
    remisSales: "Remis sales",
    retainSales: "Retainership sales",
    ussdSales: "USSD sales",
    voucherSales: "Voucher sales",
    maximumCapacity: "Maximum capacity",
    downloadReport: "Download report",
    resetExpiry: "Reset expiry date",
    walletHistory: "Wallet history",
    channel: "Channel",
    cardNumber: "Card number",
    nameCard: "Name on card",
    activated: "Activated",
    locked: "Locked",
    orderDate: "Order date",
    orderAmount: "Order amount",
    validity: "Validity",
    ownerEmail: "Owner's email",
    pin: "Pin",
    location: "Location",
    returnBalance: "Return balance",
    vehicle: "Vehicle",
    voucherCardNo: "Voucher/Card No",
  },

  drystock: {
    productSold: "Product Sold",
    Size: "Size",
    qtySold: "QTY sold",
    source: "Source",
    emptySales: "No Sales History",
    itemsSold: "items sold",
    unitAmount: "Unit amount",
    emptySalesDetails: "No sales details",
    salesDetails: "Sales details",
    prouctSales: " OVERALL PRODUCT SALES BY  ",
    recordSales: "Record sales",
    dryStockSales: "DRY STOCK SALES",
    customerName: "Customer name",
    discountPrice: "Discount price",
    salesEmpty: "No sales available",
    quantitySold: "Quantity sold",
    paymentMode: "Payment Mode",
    recordDate: "Record date",
    enterCN: "Enter customer name",

    //EO
    lubConvert: "Lubricant conversion rate",
  },
  //

  // BE
  dryStock: {
    new: "New",
    sales: "Sales",
    totalSales: "TOTAL SALES",
    bestSeller: "Best seller",
    proSalesbyB: "Product sales by Station",
    salesSummary: "Sales Summary",
    salesHistory: "Sales History",
    productSold: "Product Sold",
    Size: "Size",
    qtySold: "QTY sold",
    source: "Source",
    emptySales: "No Sales History",
    itemsSold: "items sold",
    unitAmount: "Unit amount",
    emptySalesDetails: "No sales details",
    salesDetails: "Sales details",
    prouctSales: " OVERALL PRODUCT SALES BY  ",
    recordSales: "Record sales",
    dryStockSales: "DRY STOCK SALES",
    customerName: "Customer name",
    discountPrice: "Discount price",
    salesEmpty: "No sales available",
    quantitySold: "Quantity sold",
    paymentMode: "Payment Mode",
    recordDate: "Record date",
  },

  manualRecords: {
    title: "Manual record",
    shortDesc1: "epump is here to help you manage your non fuel products in",
    shortDesc2: "your stations",

    cardTitle1: "New record",
    cardText1:
      'Click "add record" to create record which include the opening, closing records and others parameters',
    cardTitle2: "Fix rejected record",
    cardText2:
      'Click "fix rejected record" to fix rejected record which include the opening, closing records and others parameters',
    cardTitle3: "Resolve totalizer change",
    cardText3:
      'Click "resolve totalizer change" to resolve totalizer which include the opening, closing records and others parameters.',
    cardTitle4: "View Record list",
    cardText4:
      'Click "view record list" to view all manual records per date range.',

    rejectedRec: "Rejected records",
    resolvedTot: "Resolved totalizer",
    resolveNewChange: "Resolve new change",
    whichPump: "Which pump do you want to update?",
    selectPump: "Select pump",
    openingReading: "Opening reading",
    openingReadingL: "Opening reading(Ltrs)",
    closingReading: "Closing reading",
    closingReadingL: "Closing reading(Ltrs)",
    openingDip: "Opening dip",
    openingDipL: "Opening dip(Ltrs)",
    closingDip: "Closing dip",
    closingDipL: "Closing dip(Ltrs)",
    rtt: "Return to tank",
    rttL: "Return to tank(Ltrs)",
    volSold: "Volume sold",
    volFilled: "Volume filled",
    updatePumpRec: "Update pump record",
    fixRejectedRecord: "Fix rejected record",
    fixNow: "Fix now",
    dipTime: "Dip time",
    volDischarged: "Volume discharged",
    amount: "Amount",
    paymentType: "Payment type",
    description: "Description",
    tanks: "Tanks",
    pumps: "Pumps",
    expense: "Expense",
    retainership: "Retainership",
    dryStock: "Dry stock",
    pos: "POS",
    posTransact: "POS Transactions",
    expenseRecords: "Expense records",
    summary: "Summary",
    submit: "Submit",
    next: "Next",
    previous: "Previous",
    totalProSales: "Total product sales",
    totalProVol: "Total product volume",
    previousEx: "previous expenses",
    skipToSummary: "skip to summary",
    skipToExpenses: "skip to expenses",
    skipToTanks: "skip to tanks",
    skipToPOS: "skip to POS",
    setZeroSales: "set zero sales",
    outOf: "out of",
    uploadTotImage: "Upload totalizer image",
    uploadPicture: "Upload a picture",
    imageDesc: "PNG, JPG (max. 800x400px)",
    totalOuterSales: "Total outer sales",
    totalInnerSales: "Total inner sales",
    totalPumpSales: "Total pump sales",
    totalTankSales: "Total tank sales",
    transfer: "Transfer",
    uploadingImage: "Uploading image",
    recordTankDipping: "Record dippings",
    tankDipping: "Tank dippings",
    recordType: "Record type",
    valueType: "Value type",
    tankHeight: "Tank height",
    tank: "Tank",
    changedBy: "Changed by",
    selectTank: "Select tank",
    selectType: "Select type",
    calcReading: "Calculate reading.",
    plateNumber: "Plate number",
    selectReadType: "Select reading type",
    selectValueType: "Select value type",
    heightZero: "Height cannot be zero",
    errorUploadImage: "Error uploading image, please retry",
    rttGsales: "RTT cannot be greater than sales",
    openingGclosing: "opening reading cannot be greater than closing reading",
    openingGclosingDis:
      "Closing dip cannot be more that Opening Dip + Discharge",
    value: "Value",
    recordList: "Record list",
    dateRejected: "Date rejected",
  },

  remis: {
    remis: "Remis",
    remisWallet: "Remis wallet",
    remisFueling: "Remis fueling",
    walletBalance: "Wallet Balance",
    fundWallet: "Fund wallet",
    settlement: "Settlement",
    requestSettlement: "Request settlement",
    transactionDetails: "Transaction details",
    settlementDetails: "Settlement details",
    generateCode: "Generate code",
    copyCode: "Copy code",
    requestNow: "Request now",
    instruction: "Instruction",
    balance: "Balance",
    clickSettleBalance: "Click to settle from entire balance",
    outstandingPayment: "Outstanding payment",
    totalSales: "Total sales",
    accountDetails: "Account details",
    accountNumber: "Account number",
    requestTime: "Request time",
    settlementStatus: "Settlement status",
    totalRequested: "Total requested",
    requestSuccessful: "Request successful",
    requestFailed: "Request failed",
    ussd: "USSD",
    transactionDate: "Transaction date",
    refNo: "Reference no.",
    //NEW
    totalVol: "Total Vol.",
    noWalletTransact: "No wallet transactions",
    noSettlementTransact: "No settlement transactions",

    cardSummary: "Card summary",
    totalCards: "Total cards",
    soldCards: "Sold cards",
    unsoldCards: "Unsold cards",
    curCardPrice: "Current card price",
    availableCards: "Available cards",
    pendingReq: "Pending request",
    approvedReq: "Approved request",
    issuedCards: "Issued cards",
    unissuedCards: "Unissued cards",
    redeemed: "Redeemed",
    available: "Available",
    transferred: "Transferred",
    confirmSettlement: "Confirm Settlement",
    companyWallet: "Company wallet",
    initialPosting: "Initial posting",
    successPost: "Successfully confirmed settlement",
    identifier: "Identifier",
    currentApprover: "Current Approver",
    approver: "Approver",
    requestSuccess: "Request successfully",
    requestApproved: "Request approved",
    tranRef: "Transaction reference",
    cardTrans: "Card transaction History",
    isUsed: "Is Used",
    voucherDetails: "Voucher details",
    cardRequests: "Card requests",
    cardPinResetSuccess: "Card pin reset successful",
  },

  bankDeposit: {
    bankDeposit: "Bank deposit",
    addNew: "Add new deposit",
    addDeposit: "Add deposit",
    confirmedDeposits: "Confirmed deposits",
    totConfirmedDeposits: "Total confirmed deposits",
    pendingDeposits: "Pending deposits",
    totPendingDeposits: "Total Pending deposits",
    generateReference: "Generate reference",
    dateOfDeposit: "Date of deposit",
    addMore: "Add more",
    swiftCode: "Swift code",
    depositDetails: "Deposit details",
    shareCode: "Share code",
    downloadImage: "Download image",
    transactionId: "Transaction ID",
    days: "Days",
    pending: "Pending",
    confirmed: "Confirmed",
    genOn: "Generated on",
    step1: "Step 1: Go to the nearest bank",
    step2: "Step 2: Request to make PAYDIRECT payment",
    step3: "Step 3: Merchant name is Remis",
    step4: "Step 4: Provide your Shift Code",
    refCode: "Ref. Code",
    card: "Card",
    transaction: "Transaction",
    overallDeposit: "Overall deposit",
    totalDeposit: "Total deposit",
    credit: "Credit",
    debit: "Debit",
    boxDesc:
      "Add a bank deposit to easily log incoming payments and keep your account balances up to date.",
    selectProvider: "Select provider",
    remita: "Remita",
    genRemita: "generate code using remita",
    payDirect: "Pay direct",
    genPD: "generate code using pay direct",
    selPayMtd: "Select payment method",
    fillOutForm: "fill out form before you can proceed",
    copied: "Copied",
    payStack: "Paystack",
  },

  maintenence: {
    tile: "maintenance",
    mRequest: "Maintenance requests",
    fixed: "Fixed",
    fixing: "Fixing",
    notFixed: "Not fixed",
    activityLog: "Activity log",
    addRequest: "Add request",
    requestType: "Request type",
    items: "Items",
    urgencyLevel: "Urgency level",
    recBy: "Recorded by",
    servicingCom: "Servicing company",
    techName: "Technician name",
    priority: "Priority",
    close: "Close",
    closeTicket: "Close ticket",
    cost: "Maintenence cost",
    inputMCost: "Enter maintenence cost",
    addMCost: "Add maintenence cost",
    description: "Request description",
    enterDescription: "Enter Request description",
    reasonForDecline: "Reason for decline",
    enterReasonForDecline: "Enter reason for decline",
    enterReasonComment: "Enter reason/comment",
    enterFaultDesc: "Enter fault description",
  },

  services: {
    services: "Services",
    serviceMgt: "Service management",
    serviceTransact: "Service transactions",
    add: "Add service",
    addPayment: "Add payment",
    edit: "Edit service",
    manageTransact: "Manage transactions",
    sName: "Service name",
    sDesc: "Service description",
    sAdded: "Successfully added service",
    sEdit: "Successfully edited service",
    stationBreakdown: "Station breakdown",
    successDelete: "Successfully deleted service",
  },

  invoice: {
    title: "Invoice",
    details: "Invoice Details",
    overdue: "Overdue",
    due30: "Due within next 30 days",
    due: "Due",
    amtDue: "Amount due",
    allInvoices: "All invoices",
    partPaid: "Part paid",
    paid: "Paid",
    makePay: "Make payment",
    bankTransfer: "Bank transfer",
    payFromWallet: "Pay from wallet",
    settleInvoice: "Settle invoice",
    downloadPdf: "Download PDF",
    paymentHistory: "Payment history",
    paymentMtd: "Payment method",
    note: "Note",
    enterAmountToPay: "Enter amount to pay",
    enterAmountZero: "Enter amount greater than zero",
    walletBalNotEnough: "Wallet balance not enough for transaction",
    invoiceSuccess: "Invoice settled successfully",
    invoiceDownloaded: "Invoice downloaded",
    stripe: "Stripe",
    pStripe: "Pay with Stripe",
    pStack: "Pay with Paystack",
    noInvoice: "No invoices",
    billedTo: "Billed to",
    invoiceNo: "Invoice Number",
    payDue: "Payment Due",
    invoiceDate: "Invoice Date",
    subTot: "Sub-total",
    subAlert: "Subscription alert",
    yourSubWillEx: "Your subscription will expire",
    yourSubWillExd: "Your subscription expired on",
    yourSubWillExd1: "Your subscription expired",
    yourSubWillExOn: "Your subscription will expire on",
    pleaseRenewToAvoid: "Please renew to avoid service disruption",
    renewNow: "Renew now",
    renewSub: "Renew Subscription",
    subEx: "Subscription expired",
    accessCurrentlyDisabled:
      "Access to features is currently disabled.Please renew to continue using EPUMP",
    accessCurrentlyDisabledCom:
      "Acess to features is currently disabled. Please reachout to your Company to renew in order to continue using EPUMP",
    disabledDueDate:
      "Your service will be disabled if you fail to make payment before the due date. Thank you.",
    continueToPortal: "Continue to Portal",
  },

  payments: {
    inputUSD: "Input amount in USD",
    inputAmount: "Input amount",
    inputAmount2: "Input amount (no decimals)",
    poweredBy: "... powered by STRIPE",
    poweredByS: "... powered by STRIPE",
    poweredByP: "... powered by PAYSTACK",
    loadingStripe: "loading stripe",
    loadingPaystack: "loading paystack",
    payNow: "Pay Now",
    confirmingPayment: "Confirming your payment...",
    paymentConfirmed: "Payment Confirmed!, please wait",
    errorConfirming:
      "Error Confirming your payment, Please contact our support team.",
    errorConfirmingStripe:
      "Error Confirming your payment, Please refresh page. If the error persists, check your wallet to see if your funding have reflected before trying to fund wallet again",
    fundWithCard: "Fund with Card",
    wallet: "Wallet",
    fundAccountWithCard: "Fund your Account by paying with your card online",
    payNow: "Pay Now",
    fundAccountWithWallet: "Fund your account with your station Wallet",
    paymentSucceeded: "Payment succeeded!, please wait",
    paymentProcessing: "Payment processing!",
    paymentNotSuccessful: "Your payment was not successful, please try again.",
    somethingWentWrong: "Something went wrong.",
    unexpectedError: "An unexpected error occurred.",
    checking: "checking...",
    downloading: "Downloading",
    settlingInvoice: "Settling Invoice",
    invoiceSettledRe: "Invoice settled, redirecting...",
    pWindowClosed: "Payment window closed",
    psWait: "Please wait...",
    routingPaystack: "Routing to paystack",
    youWilBeCharged: "You will be charged",
    transactionFee: "transaction fee",
  },

  calibration: {
    title: "Pump Calibration",
    cLog: "Calibration log",
    calibrate: "Calibrate",
    calibration: "Calibration",
    calibratePump: "Calibrate pump",
    confirmCalibratePump: "Confirm calibration",
    confirmSchedule: "Schedule calibration",
    selectPumps: "Select pumps",
    failedPumpList: "Failed to fetch pumps in station",
    inputPass: "Input password",
    failedPumpList: "Failed to fetch pumps in station",
    currentCalib: "Current calibration",
    prevCalib: "Previous calibration",
    timeBound: "Time bound",
    passwordDescription: "Please enter password to confirm calibration update.",
    passwordDescriptionSchedule:
      "Please enter password to schedule calibration",
    CTAdesc:
      'Click on "Pump Calibration" to access the settings where you can view, adjust, or update the calibration values for the pump.',
    priceWarnTitle: "Sorry, we can't calibrate for your setup",
    priceWarnDesc: "Selected entities don't have pumps with auto clibration",
  },

  pumpCode: {
    title: "Pump Code",
    desc: "Input pump serial number and OTP seed to generate and manage pump configuration code",
    codesGenerated: "Codes generated",
    pumpSN: "Pump serial No.",
    otpSeed: "OTP seed",
    otp: "OTP",
    inputSeed: "Input seed",
    inputSN: "Input Pump S/N",
    cc: "Click to copy",
    exDate: "Expiry date",
    revoke: "Revoke",
    revokeSuccess: "Code successfully revoked",
    sureRevoke: "Are you sure you want to revoke ?",
  },

  bank: {
    bankAcctRequest: "Bank account request",
    accountName: "Account name",
    bankCode: "Bank code",
    accountType: "Account type",
    makeRequest: "Make request",
    updateBankRequest: "Update bank request",
    deleteAcctRequest: "Delete account request",
    updateSuccessful: "Update successful",
    bankAcct: "Bank accounts",
    linkedAcct: "Linked accounts",
    addBank: "Add bank",
    removeBank: "Remove bank",
    linked: "Linked",
    nonLinked: "Non-linked",
    selectAcct: "Select accounts",
    desc: "This icon indicates linked bank accounts, this means we confirm your deposit to the account. You can have multiple linked accounts",
  },
  alertAlarm: {
    title: "Alert and Alarm",
    createAA: "Create Alert/Alarm",
    updateAA: "Update Alert/Alarm",
    confirmAADelete: "Delete alarm/alert",
    sAdded: "Successfully added",
    sUpdated: "Successfully updated",
    selectEvent: "Select event",
  },

  shutdown: {
    title: "Shutdown Pump",
    shutdown: "Shutdown",
    shutdownAll: "Shutdown All",
    shutdownBy: "Shutdown by",
    shutdownSuccess: "Shutdown successful",
    sLog: "Shutdown Log",
    turnOn: "Turn On",
    turnOnAll: "Turn on all",
    turnOnSuccess: "Turn on was successful",
    confirmTurnOn: "Do you want to turn on pump?",
    scheduleTurnOn: "Schedule Turn On",
    schedule: "Schedule",
    selectSchedule: "Select date and schedule",
    passwordDescription: "Please enter the password to confirm pump shutdown",
    passwordDescriptionSchedule:
      "Please enter the password to confirm schedule pump shutdown",
    CTAdesc:
      "User can shutdown a particular pump, once done pump will not working until a revert is done on the reseting",
  },
  assets: {
    assets: "Assets",
    asset: "Asset",
    assetMgt: "Asset Management",
    assetSumary: "Assets summary",
    assetCat: "Assets categories",
    assetCats: "Assets category",
    dueAssets: "Due assets",
    name: "Asset name",
    licenseNo: "License number",
    ename: "enter asset name",
    eSn: "enter serial number",
    eLn: "enter license number",
    totalAsset: "Total Asset",
    dueForMain: "Due for maintenence",
    undergoingMain: "Undergoing maintenence",
    scheduleMaint: "Schedule maintenence",
    requestMaint: "Request maintenence",
    create: "Add asset",
    delete: "Delete asset",
    update: "Update asset",
    updateS: "Update asset status",
    updateC: "Update category",
    successCreate: "Successfully created asset",
    successDelete: "Successfully deleted asset",
    successUpdate: "Successfully updated asset",
    unMappedSuccess: "Successfully unmapped station",
    confirmUnMap: "Are you sure you want to unmap this station?",
    successStatus: "Status updated succesfully",
    warranty: "Warranty",
    exDate: "Expiry date",
    exDDate: "Expected delivery date",
    datePurchased: "Date purchased",
    mRLog: "Maintenence request log",
    logDetails: "Log details",
    okay: "Okay",
    scheduleM: "Schedule maintenance",
    scheduleDesc: "Schedule descriprion",
    frequencyDuration: "Frequency duration",
    assetBulkUpload: "Asset bulk upload",
    uploadFile: "Upload file",
    uploadHistory: "Upload History",
    uploadDetails: "Upload Details",
    maintenanceFreq: "Maintenance frequency",
    serialNumber: "Serial number",
    warrantyDate: "Warranty date",
  },

  vendor: {
    vendorMgt: "Vendor management",
    addVendor: "Add vendor",
    editVendor: "Edit vendor",
    vendor: "Vendor",
    vendorCat: "Vendor category",
    vendorName: "Vendor name",
    vendorCoverage: "Vendor's coverage",
    selectLg: "Select local government",
    vendorList: "List of vendors",
    vendorDetails: "Vendor details",
    coverageLocation: "Coverage location",
    serviceCat: "Service category",
    activateVendor: "Activate vendor",
    deactivateVendor: "Deactivate vendor",
    noRating: "Not vendor's rating yet",
    promptActivate: "Vendor needs to be activated ",
    maintenanceHistory: "Maintenance history",
    createVendor: "Create vendor",
    saveLocation: "Save location",
    vendorRating: "Vendor’s rating",
    voucher: "Voucher",
    highSLA: "High SLA hour(s)",
    mediumSLA: "Medium SLA hour(s)",
    lowSLA: "Low SLA hour(s)",
    high: "High",
    low: "Low",
    med: "Medium",
    hoursSaved: "Hours saved",
    efficiencyGraph: "Efficiency graph",
    expectedDT: "Expected delivery time",
    sla: "Service level agreement",
    efficiency: "Efficiency (hrs)",
  },

  settings: {
    profile: "Profile",
    settings: "Settings",
    information: "Information",
    details: "Details",
    banner1: "Update company profile",
    banner2:
      "Keep your pricing synchronized seamlessly between your pump and display pole. Contact us to automate your price display system",
    profileSettings: "Profile settings",
    passwordSettings: "Password settings",
    securitySettings: "Security settings",
    accountSettings: "Account settings",
    updatePassword: "Update Password",
    updateUserPassword: "Update user password",
    updateProfile: "Update Profile",
    updateDetails: "Update Details",
    noOfStations: "Number of stations",
    accountStatus: "Account status",
    subDue: "Subscription due",
    comInfo: "Company Information",
    stationInfo: "Station Information",
    personalInfo: "Personal Information",
    comDetails: "Company details",
    stationDetails: "Station details",
    comDetailsO: "This is the",
    comDetailsO2: " details overview",
    stationDetailsO: "This is the station details overview",
    perDetails: "Personal details",
    perDetailsO: "This is the personal details overview",
    erp: "ERP",
    api: "API",
    erp2: "Web hook or rest API",
    testCon: "Test connection",
    enterLinkAd: "Enter link address",
    confirmPassword: "Confirm password",
    newPassword: "New password",
    oldPassword: "Old password",
    enterNewPassword: "Enter new password",
    enterOldPassword: "Enter old password",
    contactFirstName: "Contact first name",
    contactLastName: "Contact last name",
    pushToERP: "Push to ERP",
    erpLinkSet: "ERP linking setup",
    erpModal1:
      "To link, Kindly input and save the valid ERP URL in settings page.",
    erpModal2:
      "To link, Kindly contact your Company to  input and save the valid ERP URL in settings page.",
    goToSettings: "Go to settings",
    exEpumpRec: "Export Epump record",
    exManualVol: "Export Manual volume",
    asCSV: "As CSV",
    asJSON: "As JSON",
    pushingERP: "Pushing ERP",
    pushedERP: "ERP Pushed",
  },
  equipmentReport: {
    logHistory: "Log History",
    dateUpdated: "Date updated",
    lastRecordDate: "Last record date",
    previousState: "Previous status",
    inActiveNozzle: "Inactive nozzle",
    nozzleNotSelling: "Nozzle not selling",
    inactiveTank: "Inactive tank",
    staticTankVol: "Static tank volume",
    exportAll: "Export all",
    nozzleManualRecord: "Nozzle manual record",
    tankDipReport: "Tank dip record",
    nozzle: "Nozzle",
    tank: "Tank",
  },
};
